import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ToastrModule } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmService } from '../services/confirm-dialog/confirm.service';
import { ConfirmComponent } from '../services/confirm-dialog/confirm.component';
import { CommonService } from '../services/common.service';
import { StaffCommonService } from '../services/staff-common.service';
import { Advertisement } from './../models/advertisement';
import { AdvertisementService } from '../services/advertisement.service';
import { AuthGuardService as AuthGuard } from './auth/auth-guard.service';
import { StaffAuthGuardService as StaffAuthGuard } from './auth/staff-auth-guard.service';
import { AnonymousClientAuthGuardService as AnonymousClientAuthGuard } from './auth/anonymous-client-guard.service';
import { AnonymousStaffAuthGuardService as AnonymousStaffAuthGuard } from './auth/anonymous-staff-guard.service';
import { AuthService } from './auth/auth.service';
import { ErrorInterceptor } from './auth/interceptor';

import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import { InterceptorService } from './staff-page/staff-home-page/loader/interceptor.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [AppComponent, ConfirmComponent],
  //entryComponents: [ ConfirmComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'hiworkjp' }),
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    NgxUiLoaderModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [MatButtonModule],
  providers: [
    CommonService,
    StaffCommonService,
    AdvertisementService,
    Advertisement,
    ConfirmService,
    //  JwtHelperService,
    AuthGuard,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    StaffAuthGuard,
    AnonymousClientAuthGuard,
    AnonymousStaffAuthGuard,
    CookieService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(APP_ID) private appId: string
  ) {
    const platform = isPlatformBrowser(platformId)
      ? 'in the browser'
      : 'on the server';
    console.log(`Running ${platform} with appId=${appId}`);
  }
  // @Inject(PLATFORM_ID) private platformId: Object) {
  //   if (isPlatformBrowser(platformId)) {
  //     bodyTag = document.getElementsByTagName('body')[0];
  //     htmlTag = document.getElementsByTagName('html')[0];
  //   }
  // }
}
